import React from 'react';
import { Breadcrumb } from 'antd';
import { Link } from 'react-router-dom';

export default function Breadcrumbs({ items }) {
  return (
    <Breadcrumb style={{ marginBottom: 16 }}>
      <Breadcrumb.Item>
        <Link to="/">Inicio</Link>
      </Breadcrumb.Item>
      {items.map((item, index) => (
        <Breadcrumb.Item key={item.label}>
          {index < items.length - 1 && item.to ? (
            <Link to={item.to}>{item.label}</Link>
          ) : (
            item.label
          )}
        </Breadcrumb.Item>
      ))}
    </Breadcrumb>
  );
}
